import {
  handleForcedLogout,
  updateToken,
} from "@/data/slices/authSlice";
import { refreshAccessToken } from "@/lib/api/auth";

let isRefreshing = false;
const STORE_KEY = "__COMRCE_REDUX_STORE__";
let store = globalThis[STORE_KEY];

export const initTokenFactory = (reduxStore) => {
  store = reduxStore;
  globalThis[STORE_KEY] = reduxStore;
};

export const getAccessTokenOrRefresh = async ({
  forceRefresh = false,
} = {}) => {
  const activeStore = store || globalThis[STORE_KEY];
  if (!activeStore) return "";

  const state = activeStore.getState();
  const { accessToken, expiresAt } = state.auth;

  const threshold = 30 * 1000;
  const now = Date.now();

  if (
    !forceRefresh &&
    accessToken &&
    expiresAt &&
    now < expiresAt - threshold
  ) {
    return accessToken;
  }

  const storedRefreshToken = localStorage.getItem("refresh_token");
  if (!storedRefreshToken) {
    await activeStore.dispatch(handleForcedLogout());
    return "";
  }

  if (isRefreshing) {
    // wait for refresh to finish
    while (isRefreshing) {
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
    const newState = activeStore.getState();
    return newState.auth.accessToken || "";
  }

  const refreshTokenAtStart = storedRefreshToken;

  try {
    isRefreshing = true;

    const res = await refreshAccessToken();

    const { access_token, refresh_token, expires_in } = res.data;
    const newExpiresAt = Date.now() + expires_in * 1000;

    if (localStorage.getItem("refresh_token") !== refreshTokenAtStart) {
      return "";
    }

    localStorage.setItem("refresh_token", refresh_token);
    localStorage.setItem("access_token_expires_at", newExpiresAt.toString());

    activeStore.dispatch(
      updateToken({
        accessToken: access_token,
        expiresAt: newExpiresAt,
      })
    );

    return access_token;
  } catch {
    if (localStorage.getItem("refresh_token") === refreshTokenAtStart) {
      await activeStore.dispatch(handleForcedLogout());
    }
    return "";
  } finally {
    isRefreshing = false;
  }
};
